import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
export const setRootSize = () => {
  const docEl = document.documentElement;
  const width = docEl.getBoundingClientRect().width;
  const rem = width / 10; // 适配宽度为 1920px， 分为10份 ，则 vue.config.js 中 postcss 值为 1920/10
  docEl.style.fontSize = rem + "px";
  window.rem = rem;
};
export function isEmptyObject(obj) {
  if (typeof obj !== "object" || !obj) {
    return false;
  }
  return Object.keys(obj).length === 0;
}

// 复制文本内容方法
export function copyToClipboard(textToCopy) {
  if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
    // navigator clipboard 向剪贴板写文本
    return new Promise((res, rej) => {
      navigator.clipboard.writeText(textToCopy);
      res();
    });
  } else if (document.execCommand("copy")) {
    // 创建textarea
    var textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    // 使textarea不在viewport，同时设置不可见
    textArea.style.position = "fixed";
    textArea.style.opacity = 0;
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise((res, rej) => {
      // 执行复制命令并移除文本框
      document.execCommand("copy") ? res() : rej();
      textArea.remove();
    });
  } else {
    showToast("浏览器不支持复制方法");
  }
}
export function base64ToBlob(base64, mimeType) {
  const datas = base64.split(",");
  const byteCharacters = atob(datas[1]);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, {
    type: mimeType
  });
}
export function downloadFileFromBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  // 创建一个链接元素
  let a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  // 指定下载的文件名
  a.download = filename || "share.png";
  document.body.appendChild(a);
  // 模拟点击触发下载
  a.click();
  document.body.removeChild(a);
}
export function getExtenstion(src) {
  return src.split(".").pop().toLowerCase();
}
export function isImage(filename) {
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"];
  const extension = filename.split(".").pop().toLowerCase();
  return imageExtensions.includes(extension);
}
export function isWeixinBrowser() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /micromessenger/i.test(userAgent);
}
export function isWeiboBrowser() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /weibo/i.test(userAgent);
}